export default __webpack_public_path__ + "static/media/segre22.1d2d3cbc.jpg";